import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { FC } from 'react';
import styled from 'styled-components';

type ErrorData = {
  error?: string;
  statusCode: number;
  message?: string | string[];
};

const getErrorMessage = ({ error, message }: ErrorData): string | undefined => {
  if (message) {
    if (Array.isArray(message)) {
      return message.join('\n');
    }

    return message.toString();
  }

  return error;
};

export type TApiError = FetchBaseQueryError | SerializedError | undefined;

type ApiErrorProps = {
  error: TApiError;
  color?: string;
  fontSize?: number;
  textAlign?: string;
  withMargin?: boolean;
};

export const ApiError: FC<ApiErrorProps> = ({ error, color, fontSize, textAlign, withMargin }) => {
  const props = {
    color,
    fontSize,
    textAlign,
    withMargin,
  };

  if (!error) {
    return <ApiErrorContainer />;
  }

  if ('status' in error) {
    const errMsg = 'error' in error ? error.error : getErrorMessage(error.data as ErrorData);

    return <ApiErrorContainer {...props}>{errMsg}</ApiErrorContainer>;
  } else {
    return <ApiErrorContainer {...props}>{error.message}</ApiErrorContainer>;
  }
};

const ApiErrorContainer = styled.div<{ color?: string; fontSize?: number; textAlign?: string; withMargin?: boolean }>`
  color: ${(p) => p.color || 'red'};
  font-size: ${(p) => p.fontSize || 12}px;
  min-height: 18px;
  white-space: pre-line;
  text-align: ${(p) => p.textAlign || 'left'};
  ${(p) => p.withMargin && `margin: 4px 0`};
`;
